import { Host, h } from '@stencil/core';
export class AibaWeatherDropdown {
  constructor() {
    this.handleLoadScriptGooglePlacesAPI = async () => {
      var _a;
      const scriptPresent = document.querySelector('#places-api-script');
      if (!scriptPresent) {
        const script = document.createElement('script');
        script.src = (_a = this.scriptUrl) === null || _a === void 0 ? void 0 : _a.replace('[api_key]', this.apiKey);
        script.id = 'places-api-script';
        script.async = true;
        typeof window !== 'undefined' ? document.body.appendChild(script) : null;
        await document.querySelector('#places-api-script');
      }
    };
    this.rootQuerySelectorName = 'aiba-app';
    this.inputQuerySelectorName = 'autocomplete';
    this.initiasationProps = {
      types: ['geocode'],
      componentRestrictions: { country: 'IN' },
    };
    this.handlers = undefined;
    this.onChangeHandler = undefined;
    this.value = undefined;
    this.data = undefined;
    this.reRender = false;
    this.apiKey = undefined;
    this.scriptUrl = undefined;
    this.loading = undefined;
  }
  handler(event) {
    this.error = (event === null || event === void 0 ? void 0 : event.detail) ? event === null || event === void 0 ? void 0 : event.detail : true;
    this.reRender = !this.reRender;
  }
  initialiseComponentStates(states) {
    for (const key in states) {
      if (Object.prototype.hasOwnProperty.call(states, key) && states[key] !== undefined) {
        this[key] = states[key];
      }
    }
  }
  async componentWillLoad() {
    if (this.handlers && this.handlers.getWeatherDropdownInitialisationProps) {
      let { rootQuerySelectorName, inputQuerySelectorName, initiasationProps, apiKey, scriptUrl } = await this.handlers.getWeatherDropdownInitialisationProps();
      this.initialiseComponentStates({
        rootQuerySelectorName,
        inputQuerySelectorName,
        initiasationProps,
        apiKey,
        scriptUrl,
      });
    }
    this.handleLoadScriptGooglePlacesAPI();
  }
  async placeChangedEventListener() {
    const place = this.autoCompleteObject.getPlace();
    this.onChangeHandler && (await this.onChangeHandler(place));
    this.handlers && this.handlers.handlePlacesChanged && (await this.handlers.handlePlacesChanged(place));
  }
  /*istanbul ignore next*/
  initAutocomplete() {
    // Create the autocomplete object
    // eslint-disable-next-line
    /*@ts-ignore*/
    this.autoCompleteObject = new window.google.maps.places.Autocomplete(document.querySelector(this.rootQuerySelectorName).shadowRoot.getElementById(this.inputQuerySelectorName), Object.assign({}, this.initiasationProps));
    // Add a listener for the place_changed event
    this.autoCompleteObject.addListener('place_changed', async () => {
      await this.placeChangedEventListener();
    });
  }
  /*istanbul ignore next*/
  componentDidLoad() {
    let pollingCount = 0;
    const maxPollingAttempts = 80; // Max polling attempts (100ms * 80 = 8 seconds)
    const intervalId = setInterval(() => {
      pollingCount++;
      // eslint-disable-next-line
      /*@ts-ignore*/
      if (window.google || pollingCount >= maxPollingAttempts) {
        // eslint-disable-next-line
        /*@ts-ignore*/
        if (window.google && Object.keys(window.google).length) {
          this.initAutocomplete();
          clearInterval(intervalId);
        }
      }
    }, 100);
  }
  render() {
    return (h(Host, { class: `${this.error && this.error.length ? 'error' : ''} ${this.loading}` }, h("input", Object.assign({}, this.data['input'], { id: "autocomplete", type: "text", value: this.value && this.value.split(':').length && this.value.split(':')[0] ? this.value.split(':')[0] : '', onChange: e => {
        this.handlers && this.handlers.handleWeatherInputOnChange && this.handlers.handleWeatherInputOnChange(e);
      }, onKeyDown: event => this.handlers && this.handlers.handleWeatherInputKeyDown && this.handlers.handleWeatherInputKeyDown(event), disabled: this.loading && this.loading.length, onMouseDown: () => this.handlers && this.handlers.handleFirstInteractionWeatherDropdown && this.handlers.handleFirstInteractionWeatherDropdown(), onTouchStart: () => this.handlers && this.handlers.handleFirstInteractionWeatherDropdown && this.handlers.handleFirstInteractionWeatherDropdown() }))));
  }
  static get is() { return "aiba-weather-dropdown"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-weather-dropdown.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-weather-dropdown.css"]
    };
  }
  static get properties() {
    return {
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "onChangeHandler": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "on-change-handler",
        "reflect": false
      },
      "value": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "value",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "loading": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "loading",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "rootQuerySelectorName": {},
      "inputQuerySelectorName": {},
      "initiasationProps": {},
      "reRender": {},
      "apiKey": {},
      "scriptUrl": {}
    };
  }
  static get listeners() {
    return [{
        "name": "event-options-error-weather",
        "method": "handler",
        "target": "window",
        "capture": true,
        "passive": false
      }];
  }
}
/*
TEST CASES IGNORED

1) componentDidLoad -[Lines 107 - 123] - ignored as window methodds are not available in testing environment & not able to check same
2) initAutocomplete - [Lines 90 - 105] - ignored as the google API method in not able to
*/
//# sourceMappingURL=aiba-weather-dropdown.js.map
